<template>
  <el-tree-select
    v-model="searchTheme"
    :props="themeTree.treeProps"
    :data="themeTree.treeData"
    node-key="uid"
    show-checkbox
    accordion
    multiple
    collapse-tags
    collapse-tags-tooltip
    style="width: 200px"
    :render-after-expand="false"
    @check-change="handleCheckTheme"
    @change="handleChangeTheme"
  />
</template>

<script setup>
import {
  ref,
  reactive,
  defineEmits,
  watch,
  defineProps,
  defineExpose,
  onMounted,
  computed,
} from "vue";
import { httpPost } from "@/api/httpService";

const props = defineProps({
  value: {
    type: String,
    default: "",
  },
});

const emits = defineEmits(["change", "update:value"]);

const themeTree = ref({
  treeData: [],
  treeProps: {
    label: "title",
    children: "children",
  },
});
const searchTheme = ref([]);
const searchNoSubTheme = ref([]);
watch(
  () => props.value,
  (newVal) => {
    searchTheme.value = newVal;
  },
  {
    immediate: true,
    deep: true,
  }
);

//获取树形结构
const getLiteratureCatalog = async () => {
  let res = await httpPost("/literatureTopic/v1/searchTopicStructure");
  if (res.code == 0) {
    const structure = res.data.structure;
    // themeTree.value.treeData = [
    //   {
    //     uid: 0,
    //     title: "全部",
    //     children: structure,
    //   },
    // ];
    structure.forEach((item) => {
      item.children.push({
        title: "无子主题",
        uid: "noSubUid_" + item.uid, //标识是无子主题
      });
    });
    themeTree.value.treeData = structure;
    searchTheme.value = [];
    searchNoSubTheme.value = [];
  }
};
//选中主题
const handleCheckTheme = (data, isChecked) => {
  if (isChecked) {
    if (!data.children) {
      if (data.title == "无子主题") {
        searchNoSubTheme.value.push(data.uid);
      } else {
        searchTheme.value.push(data.uid);
      }
    }
  } else {
    if (!data.children) {
      if (data.title == "无子主题") {
        searchNoSubTheme.value = searchNoSubTheme.value.filter(
          (item) => item != data.uid
        );
      } else {
        searchTheme.value = searchTheme.value.filter(
          (item) => item != data.uid
        );
      }
    }
  }
};
const handleChangeTheme = () => {
  emits("update:value", searchTheme.value);
  emits("change", {
    searchTheme: searchTheme.value,
    searchNoSubTheme: searchNoSubTheme.value,
  });
};

onMounted(() => {
  getLiteratureCatalog();
});
</script>
